export const menuData = [
  { title: "Acasă", link: "/" },
  { title: "Cauza", link: "/#cauza" },
  { title: "Ediții anterioare", link: "/#istoric" },
  { title: "Sponsori", link: "/#sponsori" },
  { title: "FAQ", link: "/#faq" },
  { title: "Contact", link: "/#contact" },
  { title: "Rotaract", link: "/rotaract" },
];
